import gql from 'graphql-tag';

export default gql`
    query ($organizationId: String!) {
        IFrameWidgetsHost(organizationId: $organizationId)
    }
`;
